// 符号
export const expressionList = [
  { value: 'eq', label: '=' },
  { value: 'ge', label: '≥', disabled: false },
  { value: 'gt', label: '>', disabled: false },
  { value: 'lt', label: '<', disabled: false },
  { value: 'le', label: '≤', disabled: false }
]
